module.exports = __webpack_public_path__ + "static/10_rot2-2-971fa7bc01e4fbfe200fb15eb37f4944.png";